import fontawesome from './component/fontawesome/fontawesome';
import header_menu from './component/header_menu/header_menu';
import index_page from './page/index';

document.addEventListener('DOMContentLoaded', () => {
    header_menu();
    fontawesome();
    index_page();
})